module.exports = __webpack_public_path__ + "img/GAME_LIGHTBUG2.1e575fc7.jpg";